export default {
    general: {
        name: 'Name',
        email: 'E-Mail',
        description: 'Beschreibung',
        status: 'Status',
        date: 'Datum',
        id: 'ID',
        size: 'Größe',
        add: 'Hinzufügen',
        data: 'Daten',
        more_info: 'Weitere Informationen',
        all: 'Alle',
        clear_filters: 'Filter löschen',
        expand_columns: 'Spalten erweitern',
        filter_mode: 'Filtermodus',
        filter_contains: 'Enthält',
        filter_not_contains: 'Enthält nicht',
        filter_equals: 'Gleich',
        filter_not_equals: 'Ungleich',
        filter_starts_with: 'Beginnt mit',
        filter_ends_with: 'Endet mit',
        filter_less_than: 'Kleiner als',
        filter_less_than_or_equal: 'Kleiner oder gleich',
        filter_greater_than: 'Größer als',
        filter_greater_than_or_equal: 'Größer oder gleich',
        filter_in_range: 'Im Bereich',
        filter_before: 'Vor',
        filter_after: 'Nach',
        filter_from: 'Von',
        filter_to: 'Bis',
        reload: 'Neu laden',
        reset_column_widths: 'Spaltenbreiten zurücksetzen',
        resize_column: 'Spaltenbreite ändern',
        search: 'Suchen',
        yes: 'Ja',
        no: 'Nein',
        list: 'Liste',
        download: 'Herunterladen',
        approve: 'Genehmigen',
    },
    nav: {
        tasks: 'Aufgaben',
        projects: 'Projekte',
        invoices: 'Rechnungen',
        submit_request: 'Anfrage einreichen',
        logout: 'Abmelden',
    },
    task: {
        list_open: 'Öffnen',
        list_in_confirmation: 'In Bestätigung',
        list_finished: 'Abgeschlossen',
        status_unassigned: 'Nicht zugewiesen',
        status_open: 'Öffnen',
        status_in_progress: 'In Bearbeitung',
        status_waiting: 'Warten',
        status_sent_for_confirmation: 'Zur Bestätigung gesendet',
        status_confirmed: 'Bestätigt',
        status_invoiced: 'Abgerechnet',
        denied_letter: 'D',
        title: 'Aufgabentitel',
        branch_office: 'Niederlassung',
        assigned_user: 'Zugewiesener Benutzer',
        added: 'Hinzugefügt',
        deadline: 'Frist',
        contact: 'Kontakt',
        adding_failed: 'Hinzufügen der Anfrage fehlgeschlagen',
    },
    project: {
        leader: 'Projektleiter',
        total_tasks: 'Gesamtaufgaben',
        finished_tasks: 'Fertige Aufgaben',
        completed: 'Abgeschlossen',
        offer_id: 'Angebots-ID',
        waiting_for_leader: 'Warten auf Bestätigung des Projektleiters',
        waiting_for_client: 'Warten auf Kundenbestätigung',
        finished: 'Projekt abgeschlossen',
        denial_reason: 'Verweigerungsgrund:',
    },
    invoice: {
        number_of_tasks: 'Anzahl der Aufgaben',
        invoice_file: 'Rechnung',
        times: 'Zeiten',
        transport: 'Transport',
        transport_names: 'Transportarten',
        kilometers: 'Kilometer',
        total_time: 'Gesamtzeit',
        task_ids: 'Aufgaben-IDs',
        files: 'Dateien',
        finished: 'Abgeschlossen',
        approved_by: 'Genehmigt durch',
        open_printout: 'Ausdruck öffnen',
    },
    client: {
        select: 'Kunde',
        change_failed: 'Wechsel fehlgeschlagen',
    },
    login: {
        title: 'Anmeldung',
        subtitle: 'Willkommen zurück, bitte melden Sie sich in Ihrem Konto an.',
        password: 'Kennwort',
        forgot_password: 'Kennwort vergessen?',
        submit: 'Anmeldung',
        failed: 'Anmeldung fehlgeschlagen',
        language: 'Sprache',
        reset_password: 'Kennwort zurücksetzen',
        send_reset_mail: 'Anfrage senden',
        reset_text: 'Mail mit Link und Anweisungen wurde an Sie gesendet!',
        password_reset_success: 'Kennwort wurde erfolgreich geändert',
        new_password: 'Neues Kennwort',
        reset_mail_already_sent: 'Zurücksetzungs-E-Mail wurde bereits gesendet',
        back_to_login: 'Zurück zur Anmeldung',
    },
    register: {
        title: 'Registrieren',
        last_name: 'Nachname',
        confirm_password: 'Bestätige das Kennwort',
        verification_sent: 'Bestätigungs-E-Mail wurde gesendet!',
        failed: 'Registrierung fehlgeschlagen',
    },
    confirm_mail: {
        title: 'Email Bestätigung',
        confirmed: 'E-Mail-Adresse wurde erfolgreich bestätigt!',
        failed: 'E-Mail-Adresse konnte nicht bestätigt werden!',
    },
    errors: {
        generic_error: 'Ein Fehler ist aufgetreten',
        invalid_data: 'Ungültige Daten',
        not_found: 'Nicht gefunden',
        on_add: 'Fehler beim Hinzufügen',
        on_edit: 'Fehler beim Aktualisieren',
        unauthorized: 'Nicht autorisiert',
        page_not_found: 'Seite nicht gefunden',
        back_home: 'Zurück zur Startseite',
    },
    success: {
        add: 'Erfolgreich hinzugefügt',
        edit: 'Erfolgreich aktualisiert',
    },
    validation: {
        required: 'Dieses Feld ist erforderlich',
        email: 'Ungültige E-Mail-Adresse',
    },
    brand: {
        product_name: 'ITOMS',
    },
    layout: {
        open_menu: 'Menü öffnen',
        close_menu: 'Menü schließen',
    },
    color_mode: {
        switch_to_light: 'Zum hellen Modus wechseln',
        switch_to_dark: 'Zum dunklen Modus wechseln',
    },
}
